import './InvoicesAccess.scss';

import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Price from '@/common/components/blocks/Price/Price';
import ListSort from '@/ebat/components/blocks/ListSort/ListSort';
import ButtonInvoice from '@/ebat/components/blocks/Order/Actions/ButtonInvoice/ButtonInvoice';
import SortOptions from '@/ebat/constants/sort';

import {
  InvoicesAccessDefaultProps,
  InvoicesAccessPropTypes,
} from './InvoicesAccess.proptypes';

const InvoicesAccess = ({ invoices, number }) => {
  const { t, i18n } = useTranslation();
  const { INVOICE_LIST_SORT } = SortOptions();

  /**
   * Format date with give format
   * @param date
   * @param {string} format
   */
  const getDate = useCallback(({ date, format }) => i18n.format(date, format), [
    i18n,
  ]);

  return (
    <>
      <h1 className="rs-modal-title">{t('common:entities.order.invoices')}</h1>
      <div className="invoices" data-qa-id="modal-invoices">
        <ListSort
          className="invoices__sort"
          staticOptions={INVOICE_LIST_SORT}
        />
        <ul className="invoices__list">
          {invoices.length > 0 &&
            invoices.map((invoice) => (
              <li key={`invoice_${invoice.id}`}>
                <div className="invoice">
                  <span className="invoice__data">
                    {getDate({ date: invoice.date, format: 'short' })}
                  </span>
                  <span className="invoice__data">{invoice.id}</span>
                  <div className="invoice__data">
                    <Price value={invoice.total_raw} />
                  </div>
                  <div className="invoice__data">
                    <ButtonInvoice
                      context="invoice-access"
                      id={invoice.id}
                      number={number}
                    />
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

InvoicesAccess.defaultProps = {
  ...InvoicesAccessDefaultProps,
};

InvoicesAccess.propTypes = {
  ...InvoicesAccessPropTypes,
};

export default InvoicesAccess;
